module.exports = __webpack_public_path__ + "img/solution_homecare.cf0d293d.jpg";